import axios from "axios";

const BASE_API_URL = "/api/visit";

//進站打點：前端每次切換頁面記錄一筆，供後台數據中心統計
class VisitService {
  //fire-and-forget：打點失敗不影響使用者體驗
  track(path) {
    return axios.post(BASE_API_URL, { path }).catch(() => {});
  }
}

export default new VisitService();
